import { NoResultsIcon } from 'assets';
import { Button } from 'view/components';
import { useNavigate } from 'react-router-dom';
import * as S from './styled';

const NoResultsBlock = ({ title, subTitle, withButton = false }) => {
  const navigate = useNavigate();

  return (
    <S.NoResultsBlock>
      <S.NoResultsBlockMain>
        <NoResultsIcon style={{ marginBottom: '24px' }} />
        <S.NoResultsBlockMainTitle>{title}</S.NoResultsBlockMainTitle>
        <S.NoResultsBlockMainSubTitle style={{ marginBottom: withButton ? '24px' : '0px' }}>
          {subTitle}
        </S.NoResultsBlockMainSubTitle>
        {withButton && (
          <Button
            variant="contained"
            text="Post a job"
            onClick={() => {
              return navigate('/create-job-post/setup');
            }}
          />
        )}
      </S.NoResultsBlockMain>
    </S.NoResultsBlock>
  );
};

export default NoResultsBlock;
